import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  CardActions,
  Typography,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../../../components/misc/Loading";
import { getNotification } from "../../../reduxToolkit/features/adminPanel/notification";
import {
  addChatAgent,
  deleteChatAgent,
  editChatAgent,
  getChatAgents,
} from "../../../reduxToolkit/features/adminPanel/webSettings";
import { colors, radii, shadows, fonts } from "../../../theme/designTokens";
import PageHeader from "../../../components/adminPanel/shared/PageHeader";
import SectionLabelChip from "../../../components/adminPanel/shared/SectionLabelChip";

// Icons
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export default function ManageChatBot() {
  const dispatch = useDispatch();
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingAddAgent, setLoadingAddAgent] = useState(false);
  const [addAgentDlg, setAddAgentDlg] = useState(false);
  const newAgentInit = {
    name: "",
    langCode: "",
    contactInfo: [
      {
        iconUrl: "",
        contactLink: "",
      },
    ],
    daysActive: [
      { title: "Sat", active: false },
      { title: "Sun", active: false },
      { title: "Mon", active: false },
      { title: "Tue", active: false },
      { title: "Wed", active: false },
      { title: "Thu", active: false },
      { title: "Fri", active: false },
    ],
  };
  const [newAgent, setNewAgent] = useState(newAgentInit);

  const [agents, setAgents] = useState([]);

  const [editDlg, setEditDlg] = useState(false);

  const [dltDlg, setDltDlg] = useState(false);
  const [dltBuffer, setDltBuffer] = useState({});

  // Local Store
  const localAdminData = JSON.parse(localStorage.getItem("adminLoginInfo"));
  // store
  const { chatAgents } = useSelector((state) => state.webSettings);

  const handleDateCheckBox = (index) => {
    let obj = { ...newAgent };
    let arr = obj.daysActive;
    arr[index].active = !arr[index].active;
    obj.daysActive = arr;
    setNewAgent(obj);
  };

  const handleAddAgentClose = () => {
    setAddAgentDlg(false);
    setEditDlg(false);
    setNewAgent(newAgentInit);
  };

  const handleAddAgent = () => {
    setLoadingAddAgent(true);
    let obj = { ...newAgent };
    if (localAdminData._id) obj.creatorId = localAdminData._id;
    dispatch(addChatAgent(obj));
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getChatAgents());
      setLoadingAddAgent(false);
      handleAddAgentClose();
    }, 1000);
  };

  const handleEditAgent = () => {
    setLoadingAddAgent(true);
    let obj = { ...newAgent };
    if (localAdminData._id) obj.creatorId = localAdminData._id;
    dispatch(editChatAgent(obj));
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getChatAgents());
      setLoadingAddAgent(false);
      handleAddAgentClose();
    }, 1000);
  };

  const handleAddContactPlatform = () => {
    const obj = { ...newAgent };
    let arr = [...obj.contactInfo];
    arr.push({
      iconUrl: "",
      contactLink: "",
    });
    obj.contactInfo = arr;
    setNewAgent(obj);
  };

  const handleRemoveContactPlatform = (index) => {
    const obj = { ...newAgent };
    let arr = [...obj.contactInfo];
    arr = arr.filter((a, i) => i !== index);
    obj.contactInfo = arr;
    setNewAgent(obj);
  };

  const handleEditClick = (x) => {
    setEditDlg(true);
    let obj = {
      _id: x._id,
      createdAt: x.createdAt,
      creatorId: x.creatorId,
      langCode: x.langCode,
      name: x.name,
      updatedAt: x.updatedAt,
    };
    let contactInfoArr = [];
    if (x.contactInfo && x.contactInfo.length > 0) {
      x.contactInfo.forEach((y) => {
        let contactInfoObj = {
          iconUrl: y.iconUrl,
          contactLink: y.contactLink,
        };
        contactInfoArr.push(contactInfoObj);
      });
    }
    let daysActiveArr = [];
    if (x.daysActive && x.daysActive.length > 0) {
      x.daysActive.forEach((y) => {
        let daysActiveObj = {
          title: y.title,
          active: y.active,
        };
        daysActiveArr.push(daysActiveObj);
      });
    }
    obj.contactInfo = contactInfoArr;
    obj.daysActive = daysActiveArr;
    setNewAgent(obj);
  };

  const handleDltClick = (x) => {
    setDltDlg(true);
    setDltBuffer(x);
  };

  const handleDltClose = () => {
    setDltDlg(false);
    setDltBuffer({});
  };

  const handleDlt = () => {
    setLoadingAddAgent(true);
    let obj = {
      id: dltBuffer._id,
    };
    if (localAdminData._id) obj.creatorId = localAdminData._id;
    dispatch(deleteChatAgent(obj));
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getChatAgents());
      setLoadingAddAgent(false);
      handleDltClose();
    }, 1000);
  };

  useEffect(() => {
    setLoadingMain(true);
    setTimeout(() => {
      if (!(chatAgents && chatAgents.length > 0)) dispatch(getChatAgents());
      setLoadingMain(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (chatAgents && chatAgents.length > 0) {
      setAgents(chatAgents);
    }
  }, [chatAgents]);

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate

  return (
    <>
      <PageHeader
        title={<SectionLabelChip label={translate0("Agents")} count={agents.length} />}
        action={
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => setAddAgentDlg(true)}
          >
            {translate0("Add Agent")}
          </Button>
        }
      />
      {loadingMain ? (
        <LoadingBox w={"100%"} />
      ) : (
        <Grid container spacing={1.5} alignItems="stretch">
          {agents.map((x, i) => (
            <Grid item key={i} xs={12} sm={6} md={4} xl={3}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: radii.lg,
                  boxShadow: shadows.card,
                  border: `1px solid ${colors.line}`,
                }}
              >
                <CardContent sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: radii.md,
                        bgcolor: colors.primaryLight,
                        color: colors.primary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <AccountBoxIcon />
                    </Box>
                    <Typography sx={{ fontFamily: fonts.display, fontWeight: 700, fontSize: 15, color: colors.ink, flex: 1 }}>
                      {x.name ? x.name : ""}
                    </Typography>
                    <img
                      src={`https://flagcdn.com/w20/${
                        x.langCode === "en" ? "gb" : x.langCode
                      }.png`}
                      alt="Flag"
                      style={{ borderRadius: 2 }}
                    />
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  {x.contactInfo &&
                    x.contactInfo.map((y, j) => (
                      <Box
                        key={j}
                        onClick={() => window.open(y.contactLink, "_blank")}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          py: 0.5,
                          cursor: "pointer",
                          fontSize: 13,
                          color: colors.ink2,
                          "&:hover": { color: colors.primary },
                        }}
                      >
                        <img
                          alt={x.name}
                          src={y.iconUrl}
                          style={{ height: "1.25rem" }}
                        />
                        <Typography noWrap sx={{ fontSize: 13 }}>
                          {y.contactLink}
                        </Typography>
                      </Box>
                    ))}
                  <Divider sx={{ my: 1 }} />
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {x.daysActive &&
                      x.daysActive.map((y, j) => (
                        <Chip
                          key={j}
                          size="small"
                          icon={
                            y.active ? (
                              <RadioButtonCheckedIcon sx={{ fontSize: 14 }} />
                            ) : (
                              <RadioButtonUncheckedIcon sx={{ fontSize: 14 }} />
                            )
                          }
                          label={y.title}
                          color={y.active ? "success" : "default"}
                          variant={y.active ? "filled" : "outlined"}
                        />
                      ))}
                  </Box>
                </CardContent>
                <CardActions
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => handleEditClick(x)}
                  >
                    {translate0("Edit")}
                  </Button>
                  <Button
                    variant="text"
                    color="error"
                    onClick={() => handleDltClick(x)}
                  >
                    {translate0("Delete")}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      {(addAgentDlg || editDlg) && (
        <Dialog open={addAgentDlg || editDlg} fullWidth maxWidth={"md"}>
          <DialogTitle>
            {editDlg ? translate0("Edit") : translate0("Add")}{" "}
            {translate0("Agents")}
          </DialogTitle>
          <DialogContent>
            <TextField
              label={translate0("Agent Name")}
              value={newAgent.name}
              onChange={(e) => {
                let obj = { ...newAgent };
                obj.name = e.target.value;
                setNewAgent(obj);
              }}
              variant="standard"
              size="small"
              fullWidth
              sx={{ mb: 1 }}
            />
            <FormControl variant="standard" fullWidth required>
              <InputLabel htmlFor="input-with-icon-adornment">
                {translate0("Language Code")}
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                value={newAgent.langCode}
                onChange={(e) => {
                  let obj = { ...newAgent };
                  obj.langCode = e.target.value;
                  setNewAgent(obj);
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src={`https://flagcdn.com/w20/${
                        newAgent.langCode === "en" ? "gb" : newAgent.langCode
                      }.png`}
                      alt="Flag"
                    />
                  </InputAdornment>
                }
              />
            </FormControl>
            <Button variant="outlined" size="small" fullWidth sx={{ mt: 1 }}>
              Contact Platforms
            </Button>
            {newAgent.contactInfo.map((x, i) => (
              <>
                <Box
                  sx={{
                    my: 1,
                    p: 1.5,
                    border: `1px solid ${colors.line}`,
                    borderRadius: radii.md,
                    bgcolor: colors.paperTint,
                  }}
                >
                  {newAgent.contactInfo.length > 1 && (
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ my: 1 }}
                      color="error"
                      onClick={() => handleRemoveContactPlatform(i)}
                    >
                      {translate0("Delete")}
                    </Button>
                  )}
                  <TextField
                    label={translate0("Icon Url")}
                    value={x.iconUrl}
                    onChange={(e) => {
                      let obj = { ...newAgent };
                      let arr = [...obj.contactInfo];
                      arr[i].iconUrl = e.target.value;
                      obj.contactInfo = [...arr];
                      setNewAgent(obj);
                    }}
                    variant="standard"
                    size="small"
                    fullWidth
                    sx={{ mb: 1 }}
                  />

                  <TextField
                    label={translate0("Contact Link")}
                    value={x.contactLink}
                    onChange={(e) => {
                      let obj = { ...newAgent };
                      let arr = [...obj.contactInfo];
                      arr[i].contactLink = e.target.value;
                      obj.contactInfo = [...arr];
                      setNewAgent(obj);
                    }}
                    variant="standard"
                    size="small"
                    fullWidth
                    sx={{ mb: 1 }}
                  />
                </Box>
              </>
            ))}
            <Button
              variant="contained"
              size="small"
              fullWidth
              sx={{ mb: 1 }}
              color="success"
              onClick={handleAddContactPlatform}
            >
              {translate0("Add Contact Platform")}
            </Button>
            <Grid container spacing={0}>
              {newAgent.daysActive.map((x, i) => (
                <Grid item key={i} xs={4} sm={1.5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={x.active}
                        onChange={() => handleDateCheckBox(i)}
                      />
                    }
                    label={x.title}
                  />
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAddAgentClose} color="primary">
              {translate0("Cancel")}
            </Button>
            <LoadingButton
              loading={loadingAddAgent}
              onClick={editDlg ? handleEditAgent : handleAddAgent}
              color={editDlg ? "warning" : "success"}
              disabled={newAgent.name === "" || newAgent.langCode === ""}
            >
              {editDlg ? translate0("Update") : translate0("Add")}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      )}

      {dltDlg && (
        <Dialog open={dltDlg}>
          <DialogTitle>
            {translate0("Do you really want to delete")} "
            <Box component="span" sx={{ color: "error.main", fontWeight: 700 }}>
              {dltBuffer.name}
            </Box>
            "?
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleDltClose} color="primary">
              {translate0("Close")}
            </Button>
            <LoadingButton
              loading={loadingAddAgent}
              onClick={handleDlt}
              color="error"
            >
              {translate0("Delete")}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
